<template lang="pug">
  div.rails
    div.rail(v-for="(n, i) in rails",:style="sty(i,n)")
      img(:src="'./static/front/'+ n.code +'.svg'")
      div.code(v-if="preview === true") {{n.code}}
    <!--div.rail(v-for="(n, i) in slits",v-if="i < slits.length - 1",:style="sty(i)")-->
      <!--img(:src="'./static/front/'+ n.rail.code +'.svg'")-->
</template>

<script>
export default {
  name: 'Rails',
  components: {
  },
  data () {
    return {
      width: 0,
      bottom: 0,
      slits: [],
      rail: [],
      rails: [],
      railspan: []
    };
  },
  props: {
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    sty (num, itm) {
      let left = 0;
      for (let i = 0; i <= num; i++) {
        left += this.rails[i].w;
      }
      left -= itm.w;
      return {
        left: this.c2p(left) + 'px',
        width: this.c2p(itm.w) + 'px',
        bottom: this.bottom + 'px'
      };
    },
    update () {
      if (this.sets[this.number] === undefined) return false;
      this.color = this.sets[this.number].color;
      if (this.color === 1) {
        this.railspan = this.acopy(this.railsspan.railspan2);
      } else {
        this.railspan = this.acopy(this.railsspan.railspan1);
      }
      this.set = this.sets[this.number];
      this.slits = this.sets[this.number].slits;
      const isLargeNumber = (element) => Number(element.w) === Number(this.set.size[0]);
      let result = this.railspan.find(isLargeNumber);
      if (result === undefined) return false;
      let interval = result.interval;
      let ary = [];
      for (let prop in interval) {
        let isLargeNumber;
        if (this.color === 1) {
          isLargeNumber = function (element) {
            let bk = element.code.substr(element.code.length - 2, 2);
            if (Number(element.w) === Number(interval[prop]) && bk === 'BK') {
              return element;
            }
          };
        } else {
          isLargeNumber = function (element) {
            if (Number(element.w) === Number(interval[prop])) {
              return element;
            }
          };
        }
        ary.push(this.railitems.find(isLargeNumber));
      }
      this.set.rails = ary;
      this.rails = this.set.rails;

      if (this.railitems !== undefined) {
        // すべて更新
        if (this.sets.length > 0 && this.set !== undefined) {
          this.width = this.c2p(this.set.size[0]);
          this.bottom = this.c2p(this.set.size[1]);
        }
      }
    }
  },
  created () {
    if (this.sets[this.number] !== undefined) {
      this.color = this.sets[this.number].color;
    }
    if (this.color === 1) {
      this.railspan = this.acopy(this.railsspan.railspan2);
    } else {
      this.railspan = this.acopy(this.railsspan.railspan1);
    }
    this.update();
  }
};
</script>

<style lang="stylus" scoped>
  .rails
    user-select none
    position absolute
    left 0
    bottom 0
    display flex
    .rail
      position absolute
      width 150px
      height 14px
      transform translate(0,100%)
      box-shadow 1px 1px 3px #00000033
      .preview &
        box-shadow none
      img
        width 100%
        height 100%
        position absolute
        top 0
        left 0
      .code
        text-align center
        position absolute
        top -20px
        left 0
        width 100%
        font-size 14px
        z-index 2
        text-shadow 1px 1px 1px #ffffff,-1px -1px 1px #ffffff,-1px 1px 1px #ffffff,1px -1px 1px #ffffff,1px 0px 1px #ffffff,-1px 0px 1px #ffffff,0px 1px 1px #ffffff,0 -1px 1px #ffffff
        //display none
        //.preview &
        //  display block
</style>



// WEBPACK FOOTER //
// src/components/front/Rails.vue